<section class="px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section class="container mx-auto flex flex-col items-center py-10 lg:py-20">
    <h3 class="text-2xl md:text-3xl lg:text-4xl text-start font-semibold">
      Featured Listings
    </h3>
    <div
      *ngIf="!isLoading; else loading"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-x-7 xl:gap-y-10 mt-5"
    >
      <span *ngFor="let listing of listings">
        <out-listing-card [listing]="listing"></out-listing-card>
      </span>
    </div>

    <ng-template #loading>
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-x-7 xl:gap-y-10 w-full mt-5"
      >
        <div *ngFor="let placeholderSkeleton of placeholderSkeletons">
          <out-listing-skeleton></out-listing-skeleton>
        </div>
      </div>
    </ng-template>
    <button
      [routerLink]="'/used-tesla-for-sale'"
      class="border-2 !border-OUT-Blue rounded-full px-4 py-2 text-OUT-Blue font-semibold w-fit hover:bg-OUT-Blue hover:text-white transition-colors duration-400 mt-10 cursor-pointer"
    >
      View All Listings
    </button>
  </section>
</section>
